import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {ControlContainer, FormControl, FormGroupDirective} from '@angular/forms';

type INPUT_MODE = 'PASSWORD' | 'TEXT';

@Component({
    selector: 'ngx-input-password',
    templateUrl: './input-password.component.html',
    styleUrls: ['./input-password.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
})
export class InputPasswordComponent {
    @Input() fc: FormControl;
    @Input() controlName: string;
    @Input() id: string;
    @Input() name: string;
    @Input() type: string;
    @Input() fieldSize: string;

    @Output() onInputChanges = new EventEmitter();

    inputMode: INPUT_MODE = 'PASSWORD';

    constructor(private ref: ChangeDetectorRef) {}

    onInputChangedEvent($event) {
        this.onInputChanges.emit($event);
    }

    setInputMode(mode: any) {
        this.inputMode = mode;
        this.ref.detectChanges();
    }

    get control(): FormControl {
        return this.fc;
    }
}
